import { HeadingDesc, SectionHeadingSmall } from '../Headings';
import './sources.css';

function Sources(props) {
  const { reviewDate, totalSources } = props;

  return (
    <div className="sources">
      <HeadingDesc text={reviewDate} />
      <SectionHeadingSmall text={totalSources} />
    </div>
  );
}

export default Sources;
